import React from 'react';
import PropTypes from 'prop-types'
import { IoIosArrowRoundForward } from "react-icons/io";
import SectionTitle from '../../../../components/ui/section-title'
import Anchor from '../../../../components/ui/anchor'
import { Container, Row, Col } from '../../../../components/ui/wrapper'
import { SectionWrap } from './section.style'
import BoxLargeImage from '../../../../components/box-large-image/layout-two'
import Masonry from 'react-masonry-css'

import image1 from '../../../../data/images/box-image/image-03-480x298.jpg'
import image2 from '../../../../data/images/box-image/image-06-480x298.jpg'
import image3 from '../../../../data/images/box-image/image-05-480x298.jpg'

const BoxSection = ({data, linkStyle, sectionTitleStyle, sectionBottomStyle, boxStyles }) => {
    return (
        <SectionWrap>
                
                <h5 style={{marginTop:'50px', marginBottom:'15px'}}>Triploaf Picks</h5>
                    <Masonry
                      breakpointCols={3}
                      className="ts-picks-grid"
                      columnClassName="ts-picks-grid_column">
                        {
                            data && data.map(boxContent => {
                                return (
                                    
                                        <BoxLargeImage
                                            {...boxStyles}
                                            imageSrc={boxContent.node.data.Photo[0].url}
                                            title={boxContent.node.data.Title}
                                            desc={boxContent.node.data.Description}
                                            path={boxContent.node.data.Link}
                                        />
                                    
                                )
                            })
                        }
                    </Masonry>
               
        </SectionWrap>
    )
}

BoxSection.propTypes = {
    sectionTitleStyle: PropTypes.object,
    headingStyle: PropTypes.object,
    linkStyle: PropTypes.object,
    boxStyles: PropTypes.object
}

BoxSection.defaultProps = {
    sectionTitleStyle: {
        mb: '20px',
        fontSize : '15px',
        align : 'left',
        responsive: {
            medium: {
                mb: '10px'
            }
        }
    },
    boxStyles: {
        headingStyle: {
            color: '#000'
        }
    },
    linkStyle: {
        layout: 'underline',
        fontSize: '18px',
        fontWeight: 500,
        lineheight: 1.40,
        color: 'primary',
        hover: {
            layout: 2
        }
    },
    sectionBottomStyle: {
        mt: '40px',
        align: 'left'
    }
}

export default BoxSection;